/**
 * D-3 (AUDITORIA-COMERCIAL) — o ouvinte do `carga:erro` (ver
 * `src/lib/aviso-carga.ts`). Montado sob o ToastProvider: quando uma carga
 * falha em qualquer tela, a pessoa OUVE — em vez de encarar um kanban vazio
 * achando que não há trabalho.
 *
 * 🔴 KIT-INSUMO-ORCAMENTISTA (28/08/2026) — o aviso deixa de mentir no 403.
 *
 * Até aqui, QUALQUER falha virava "Não foi possível carregar os dados. Confira
 * a conexão e tente de novo." O orçamentista tomava 403 no bloco do kit insumo
 * e ficava tentando de novo, porque a tela mandava. Falta de permissão não se
 * resolve tentando de novo — se resolve pedindo acesso, e é isso que a
 * mensagem passa a dizer.
 */
import { useEffect } from 'react';

import { useToast } from '@/components/ui';
import { EVENTO_CARGA_ERRO, mensagemDeCarga, type DetalheCargaErro } from '@/lib/aviso-carga';

export function AvisoDeCargaGlobal() {
  const toast = useToast();
  useEffect(() => {
    const avisar = (e: Event) => {
      const detalhe = (e as CustomEvent<DetalheCargaErro>).detail ?? null;
      toast.show(mensagemDeCarga(detalhe?.status ?? null), { variant: 'error' });
    };
    window.addEventListener(EVENTO_CARGA_ERRO, avisar);
    return () => window.removeEventListener(EVENTO_CARGA_ERRO, avisar);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return null;
}
